import React from 'react'
import {
  Route, Redirect,
} from 'react-router-dom'
import { PuffLoader } from 'react-spinners'

import { useAuth } from '../authContext'
import { PrivateLayout } from '../layouts'

export default function PrivateRoute({ children, ...rest }) {
  const [loading, setLoading] = React.useState(true)
  const auth = useAuth()

  React.useEffect(() => {
    auth.autoin(() => setLoading(false))
  }, [])

  if(loading){
    return (
      <div className="loader">
        <PuffLoader size={60} color="white" />
        <h3>Validando sesión ...</h3>
      </div>
    )
  }


  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user ? <PrivateLayout>
          { children }
        </PrivateLayout> : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  )
}